import type { IconType } from "@circle-react-shared/Icon";

export type ButtonRadiusSelectorType = "all" | "individual";

export const BUTTON_RADIUS_SELECTOR_TYPES: {
  type: ButtonRadiusSelectorType;
  icon: IconType;
}[] = [
  {
    type: "all",
    icon: "20-all-corners",
  },
  {
    type: "individual",
    icon: "20-individual-corners",
  },
];

export const CORNERS = [
  "border_left_top_radius",
  "border_right_top_radius",
  "border_right_bottom_radius",
  "border_left_bottom_radius",
];
